import '~/setup';
import 'bootstrap';
import '~/javascripts/refile';
import '~/javascripts/vendor/megamenu';
import 'sticky-sidebar/dist/jquery.sticky-sidebar';
import '~/javascripts/vendor/odometer.min';
import '~/javascripts/vendor/jquery.accordion';
import '~/javascripts/vendor/typed';
import '~/javascripts/cubbi';
import '~/javascripts/nav-scroll';
import '~/javascripts/rent-calculator';
import '~/javascripts/vendor/pgwslideshow.min';
import '~/javascripts/address_search';
import '~/javascripts/events';
import '~/javascripts/reference';

window.onload = function () {
  window.Beacon('config', {
    display: {
      zIndex: '99999999',
    },
  });
  const anchors = document.getElementsByTagName('a');

  for (let i = 0; i < anchors.length; i++) {
    const anchor = anchors[i] as HTMLAnchorElement;
    if (anchor.className.match(/openBeacon/g)) {
      anchor.onclick = function (e) {
        e.preventDefault();
        window.Beacon('open');
      };
    }
  }
};
